import { render, staticRenderFns } from "./TraktorStudio.vue?vue&type=template&id=57deafec&scoped=true&"
import script from "./TraktorStudio.vue?vue&type=script&lang=js&"
export * from "./TraktorStudio.vue?vue&type=script&lang=js&"
import style0 from "./TraktorStudio.vue?vue&type=style&index=0&id=57deafec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57deafec",
  null
  
)

export default component.exports